export default __webpack_public_path__ + "static/linkerd-jaeger-ui-9b6e7eeed00a7865da63f7ac695d1ac8.webp";